import React from "react"

const Spinner: React.FC = () => {
  return (
    <div className="spinner">
      <div className="line"></div>
    </div>
  )
}

export default Spinner
